import React, { Fragment, useState, useEffect } from "react";
import { Form, Input, Radio, Select } from "antd";
import DadataSearch from "../../../../Authorization/containers/DadataSearch/dadataSearch";
import PhoneNumberMask from "../../../../../common/inputs/AuthorizationInputs";
import { isEmail } from "../../../../../common/utils/validation";
import UploadPhoto from "../../../../../common/components/UploadPhoto/UploadPhoto";
import { BankForm } from "./BankForm";

const Option = Select.Option;

const requiredFieldRules = {
  required: true,
  message: "Поле, обязательное для заполнения"
};
const TemplateInfo = ({ form, disabled, typeForm, dadataBankSelected }) => {
  const [autoSearchFields, setFields] = useState(null);
  useEffect(() => {
    if (autoSearchFields) {
      setFieldsValue({
        nameLegal: autoSearchFields.name,
        addressLegal: autoSearchFields.address,
        inn: autoSearchFields.inn,
        kpp: autoSearchFields.kpp,
        ogrn: autoSearchFields.ogrn,
        subjectKey: autoSearchFields.opfShort === "ИП" ? "individ" : "legal"
      });
    }
  }, [autoSearchFields]);
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const subjectKey = getFieldValue("subjectKey");

  const handleChangeSubject = () => {
    form.resetFields(
      ["nameLegal", "addressLegal", "inn", "kpp", "ogrn", "dadataSearch"],
      setFields(null)
    );
  };

  const handleChange = fields => {
    setFields(fields);
  };

  const prefixPhoneCode = getFieldDecorator("phoneCode", {
    initialValue: "+7"
  })(
    <Select
      style={{ width: 80 }}
      dropdownMatchSelectWidth={false}
      optionLabelProp="value"
      placeholder="Код"
      disabled={disabled}
      getPopupContainer={trigger => trigger.parentNode}
    >
      <Option value="+7">+7 (Россия)</Option>
      <Option value="+380">+380 (Украина)</Option>
      <Option value="+375">+375 (Беларусь)</Option>
      <Option value="+77">+77 (Казахстан)</Option>
      <Option value="+994">+994 (Азербайджан)</Option>
      <Option value="+374">+374 (Армения)</Option>
      <Option value="+995">+995 (Грузия)</Option>
    </Select>
  );

  return (
    <Fragment>
      <div className="offer-card__item" hidden={true}>
        <span className="label">Лицензиат:</span>
        <Form.Item>
          {getFieldDecorator("subjectKey")(
            <Radio.Group onChange={handleChangeSubject} disabled>
              <Radio value="legal">Юридическое лицо</Radio>
              <Radio value="individ">ИП</Radio>
            </Radio.Group>
          )}
        </Form.Item>
      </div>
      {typeForm !== "create" && (
        <div className="offer-card__item" style={{ marginTop: 22 }}>
          <span className="label">Субъект исполнителя:</span>
          <Form.Item>
            {getFieldDecorator("subjectKey")(
              <Select
                style={{ width: 368 }}
                disabled
                getPopupContainer={trigger => trigger.parentNode}
              >
                <Select.Option value="legal">Юридическое лицо</Select.Option>
                <Select.Option value="individ">
                  Индивидуальный предприниматель
                </Select.Option>
              </Select>
            )}
          </Form.Item>
        </div>
      )}
      {(subjectKey || typeForm === "view" || typeForm === "edit") && (
        <Fragment>
          {(typeForm === "view" ||
            typeForm === "edit" ||
            (autoSearchFields && Object.keys(autoSearchFields).length > 0)) && (
            <div className={"executor-content__photo-" + typeForm}>
              <Form.Item>
                {getFieldDecorator("companyPhoto", {
                  rules: [],
                  valuePropName: "image_url"
                })(
                  <UploadPhoto
                    form={form}
                    disabled={disabled}
                    name="companyPhoto"
                    update={file => setFieldsValue({ companyPhoto: file })}
                  />
                )}
              </Form.Item>
            </div>
          )}
          <div className="">
            {typeForm === "create" && (
              <div className="offer-card__item" style={{marginTop: 16}}>
                <DadataSearch
                  form={form}
                  style={{ width: 368 }}
                  label={
                    <span className="label">
                      {subjectKey === "individ" ? "ИП" : "Организация"}:
                    </span>
                  }
                  handleChange={handleChange}
                />
              </div>
            )}
            {(typeForm === "view" ||
              typeForm === "edit" ||
              (autoSearchFields &&
                Object.keys(autoSearchFields).length > 0)) && (
              <>
                <div className="offer-card__item">
                  <span className="label">Наименование:</span>
                  <Form.Item>
                    {getFieldDecorator("nameLegal")(
                      <Input
                        style={{ width: 368 }}
                        disabled
                        placeholder={
                          typeForm === "view"
                            ? "Не указано"
                            : "Укажите наименование компании"
                        }
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">Юридический адрес:</span>
                  <Form.Item>
                    {getFieldDecorator("addressLegal")(
                      <Input
                        style={{ width: 368 }}
                        disabled
                        placeholder={
                          typeForm === "view"
                            ? "Не указано"
                            : "Укажите юридический адрес"
                        }
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="offer-card__item">
                  <span className="label">ИНН:</span>
                  <Form.Item>
                    {getFieldDecorator("inn", {
                      validateFirst: true,
                      rules: [
                        requiredFieldRules,
                        {
                          validator: (rule, value, callback) => {
                            if (value.length < 10) {
                              callback(true);
                            } else {
                              callback();
                            }
                          },
                          message: "Недопустимое количество символов"
                        },
                        {
                          validator: (rule, value, callback) => {
                            if (!/^[0-9]+$/.test(value)) {
                              callback(true);
                            } else {
                              callback();
                            }
                          },
                          message: "Недопустимый символ"
                        }
                      ]
                    })(
                      <Input
                        style={{ width: 368 }}
                        maxLength={15}
                        disabled
                        placeholder={
                          typeForm === "view" ? "Не указано" : "Укажите ИНН"
                        }
                      />
                    )}
                  </Form.Item>
                </div>
                {subjectKey === "legal" && (
                  <div className="offer-card__item">
                    <span className="label">КПП:</span>
                    <Form.Item>
                      {getFieldDecorator("kpp")(
                        <Input
                          style={{ width: 368 }}
                          disabled
                          placeholder={
                            typeForm === "view" ? "Не указано" : "Укажите КПП"
                          }
                        />
                      )}
                    </Form.Item>
                  </div>
                )}
                <div className="offer-card__item">
                  <span className="label">
                    {subjectKey === "legal" ? "ОРГН" : "ОГРНИП"}:
                  </span>
                  <Form.Item>
                    {getFieldDecorator("ogrn")(
                      <Input
                        style={{ width: 368 }}
                        disabled
                        placeholder={
                          typeForm === "view"
                            ? "Не указано"
                            : subjectKey !== "legal"
                            ? "Укажите ОРГН"
                            : "Укажите ОГРНИП"
                        }
                      />
                    )}
                  </Form.Item>
                </div>

                <div className="offer-card__item">
                  <span className="label">Система налогообложения:</span>
                  <Form.Item>
                    {getFieldDecorator("taxSystem")(
                      <Select
                        style={{ width: 224 }}
                        disabled={disabled}
                        placeholder={
                          typeForm === "view"
                            ? "Не указано"
                            : "Выберите с или без НДС"
                        }
                        getPopupContainer={trigger => trigger.parentNode}
                      >
                        <Select.Option value={0}>Без НДС</Select.Option>
                        <Select.Option value={1}>С НДС</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>

                <div style={{ marginTop: 24 }}>
                  <div className="offer-card__item">
                    <span className="label">Фактический адрес:</span>
                    <Form.Item>
                      {getFieldDecorator("addressFact")(
                        <Input
                          style={{ width: 368 }}
                          disabled={disabled}
                          placeholder={
                            typeForm === "view"
                              ? "Не указано"
                              : "Укажите фактический адрес"
                          }
                        />
                      )}
                    </Form.Item>
                  </div>
                  {/*<div className="offer-card__item">*/}
                  {/*  <span className="label">ID в АЦБПДП:</span>*/}
                  {/*  <Form.Item>*/}
                  {/*    {getFieldDecorator("acbpdp")(*/}
                  {/*      <Input*/}
                  {/*        style={{ width: 368 }}*/}
                  {/*        disabled={disabled}*/}
                  {/*        placeholder={*/}
                  {/*          typeForm === "view"*/}
                  {/*            ? "Не указано"*/}
                  {/*            : "Укажите код перевозчика в ЕГИС ОТБ"*/}
                  {/*        }*/}
                  {/*      />*/}
                  {/*    )}*/}
                  {/*  </Form.Item>*/}
                  {/*</div>*/}
                </div>

                <div style={{ marginTop: 24 }}>
                  <div className="offer-card__item">
                    <div className="form-item-phone">
                      <span className="label">Телефон компании:</span>
                      <Form.Item>
                        {getFieldDecorator("phone", {
                          validateFirst: true,
                          rules: [
                            {
                              required: true,
                              message: "Поле, обязательное для заполнения"
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value.length < 10) {
                                  callback(true);
                                } else {
                                  callback();
                                }
                              },
                              message: "Недопустимое количество символов"
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (!/^[0-9]+$/.test(value)) {
                                  callback(true);
                                } else {
                                  callback();
                                }
                              },
                              message: "Недопустимый символов"
                            }
                          ]
                        })(
                          <PhoneNumberMask
                            name="phone"
                            mask="(###) ###-##-##"
                            maxLength={15}
                            addonBefore={prefixPhoneCode}
                            disabled={disabled}
                            placeholder={
                              typeForm === "view"
                                ? "Не указано"
                                : "Укажите номер телефона"
                            }
                            style={{ width: 320 }}
                          />
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="offer-card__item">
                    <span className="label">E-mail для уведомлений:</span>
                    <Form.Item>
                      {form.getFieldDecorator("email", {
                        rules: [
                          {
                            validator: (rule, value, callback) => {
                              if (value.length === 0) {
                                callback("Поле обязательно для заполнения");
                              } else if (!isEmail(value)) {
                                callback("Некорректный email");
                              } else {
                                callback();
                              }
                            }
                          }
                        ]
                      })(
                        <Input
                          style={{ width: 368 }}
                          disabled={disabled}
                          placeholder={
                            typeForm === "view"
                              ? "Не указано"
                              : "Укажите e-mail"
                          }
                        />
                      )}
                    </Form.Item>
                  </div>

                  <div className="offer-card__item">
                    <span className="label" style={{ letterSpacing: -1.3 }}>
                      Сайт:
                    </span>
                    <Form.Item>
                      {getFieldDecorator("site")(
                        <Input
                          style={{ width: 368 }}
                          disabled={disabled}
                          placeholder={
                            typeForm === "view" ? "Не указано" : "Укажите сайт"
                          }
                        />
                      )}
                    </Form.Item>
                  </div>
                  <BankForm
                    form={form}
                    disabled={disabled}
                    dadataBankSelected={dadataBankSelected}
                  />
                </div>
              </>
            )}
          </div>
        </Fragment>
      )}
    </Fragment>
    /* {
    <React.Fragment>
      <div className="offer-card__item">
        <span className="label">Наименование шаблона:</span>
        <Form.Item
          help={validateName.help}
          validateStatus={validateName.status}
        >
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(<Input style={{ width: 368 }} disabled={disabled} />)}
        </Form.Item>
      </div>


      <div className="offer-card__item">
        <span className="label">Вид транспортной услуги:</span>
        {getFieldDecorator('serviceType')(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </div>
      <div className="offer-card__item">
        <span className="label">Количество пассажиров:</span>
        {getFieldDecorator('passengersCount')(
          <Input style={{ width: 80 }} disabled={disabled} />
        )}
      </div>
       }*/
  );
};

export default TemplateInfo;
